import { ChakraBox } from '@equip.health/ui';
import { STATUS_COLORS } from '../constants';
import type { StatusKey } from '../constants';

interface StatusColorDotProps {
  statusKey: StatusKey;
}

const StatusColorDot = ({ statusKey }: StatusColorDotProps) => {
  return (
    <ChakraBox
      width="10px"
      height="10px"
      borderRadius="50%"
      bg={STATUS_COLORS[statusKey]}
      flexShrink={0}
      marginTop="3px"
      data-testid={`my-day-legend-color-${statusKey}`}
    />
  );
};

export default StatusColorDot;
